import React from "react";
import {Button} from "@unibuddy/patron";

import {questionsPromptPopUpTopics} from "./QuestionsPromptPopUpConstants";

type QuestionsPromptPopUpTopicBubbleProps = {
    topic: questionsPromptPopUpTopics;
    selected: boolean;
    onClick: () => void;
};

export function QuestionsPromptPopUpTopicBubble({
    topic,
    onClick,
    selected,
}: QuestionsPromptPopUpTopicBubbleProps) {
    return (
        <Button onClick={onClick} round color={selected ? "university" : "default"} size="sm">
            {topic}
        </Button>
    );
}
